/* globals LANGUAGE_CODE */

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.View.extend({
  // This is a good place to add functions that we may want in child views.

  prevent_default: function (e) {
    e.preventDefault();
  },

  // Format the number for the locale
  num_format: function (value) {
    return Number(value).toLocaleString(LANGUAGE_CODE);
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/views/tracker.js
// module id = 160
// module chunks = 0